<div id="header">
    <div id="mobileNavigationToggle" (click)="toggleOpen()" [class.open]="mobileOpen">
    </div>

    <div id="headerLogo" class="internal" (click)="goHome()" title="Startseite"></div>

    <div id="headerNotifications">

        <elem-hd-messages class="messagesTile"
                          title="Meine Meldungen"
                          [menuShown]="messagesShown"
                          (notifyOpened)="notifyOpened($event)"></elem-hd-messages>

        <div id="sessionTimer">
            <span class="timeInteger">{{minutesLeft}}</span>
            <span class="timeUnit">Min.</span>
        </div>

        <elem-hd-personal class="personalTile"
                          title="Mein Account"
                          [menuShown]="personalShown"
                          (notifyOpened)="notifyOpened($event)"></elem-hd-personal>

    </div>

    <div class="both"></div>
</div>
